import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { TreeSelectorComponent } from '../../treeselector/treeselector.component';
import { TreeService } from '../../shared/services/tree.service';
import { TranslatePipe } from '../../shared/i18n/translate.pipe';
import { ConsentService } from '../../shared/services/consent.service';

@Component({
    selector: 'app-main-layout',
    templateUrl: './main-layout.component.html',
    styleUrls: ['./main-layout.component.css'],
    standalone: true,
    imports: [RouterLink, RouterOutlet, TreeSelectorComponent, TranslatePipe]
})
export class MainLayoutComponent implements OnInit, OnDestroy {
  version = '';
  copyright = '';

  private changeTreeSubscription: Subscription | undefined;
  private routerSubscription: Subscription | undefined;

  constructor(private treeService: TreeService, private router: Router, private cdr: ChangeDetectorRef,
    private consent: ConsentService) { }

  ngOnInit(): void {
    this.version = environment.version;
    this.copyright = environment.copyright;
    // opiekunowie przychodzą razem z danymi drzewa, więc stopka odświeża się
    // razem z jego zmianą
    this.changeTreeSubscription = this.treeService.changeTree.subscribe(() => this.cdr.detectChanges());
    this.routerSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => this.cdr.detectChanges());
  }

/** Link w stopce - baner zgody z aktualnym wyborem, do zmiany w kazdej chwili. */
  openConsent(): void {
    this.consent.open();
  }

  ngOnDestroy(): void {
    this.changeTreeSubscription?.unsubscribe();
    this.routerSubscription?.unsubscribe();
  }

  /**
   * Licznik profili należy do zwiedzania drzewa. W ustawieniach drzewa i konta
   * był tylko szumem - te strony mają własne liczby - a na telefonie zabierał
   * cały wiersz nad treścią. Dane ostatniego drzewa zostają w pamięci, więc bez
   * tego warunku licznik pokazywał się nawet w ustawieniach konta.
   */
  get showTreeCount(): boolean {
    return this.router.url.startsWith('/tree/') && !this.router.url.includes('/settings');
  }

  /**
   * Czy menu ma iść PRZED treścią (dotyczy tylko telefonu).
   *
   * W ustawieniach - drzewa, konta i panelu administratora - menu jest
   * nawigacją: bez niego nie da się przejść do sąsiedniej strony, a leżało
   * pod całą treścią, na samym dole. W widoku drzewa jest odwrotnie: gałęzie,
   * nazwiska i miejscowości to długie listy, które zajmowały cały pierwszy
   * ekran i spychały drzewo oraz profil dwa ekrany w dół - tam menu zostaje
   * pod treścią.
   */
  get menuFirst(): boolean {
    const adres = this.router.url;

    return adres.startsWith('/user-settings') || adres.startsWith('/admin')
      || (adres.startsWith('/tree/') && adres.includes('/settings'));
  }

  /** Nazwa drzewa - stopka mówi, czyim drzewem się właśnie patrzy. */
  get treeTitle() {
    return environment.currentTreeDescription;
  }

  /**
   * Opiekunowie drzewa (super administratorzy) do pierwszego wiersza stopki.
   * Bez adresów e-mail - drzewo bywa publiczne, a skrzynka opiekuna nie ma po
   * co trafiać do wyszukiwarek.
   */
  get treeAdmins(): string {
    // ustawienia konta korzystaja z tego samego ukladu, a dane ostatniego
    // drzewa zostaja w pamieci - stad warunek na adres
    if (!environment.currentTree || !this.router.url.startsWith('/tree/')) {
      return '';
    }
    return (this.treeService.currentTreeData?.admins ?? []).join(', ');
  }
}
